import React from "react";
import { Helmet } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { Link } from "react-router-dom";
import "./TermsAndConditions.css";

const IconClock = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);

const SECTIONS = [
  { id: "acceptance", label: "Acceptance of Terms" },
  { id: "information-collected", label: "Information We Collect" },
  { id: "when-we-collect", label: "When We Collect It" },
  { id: "how-we-use", label: "How We Use It" },
  { id: "changes", label: "Changes to These Terms" },
  { id: "contact", label: "Contact Us" },
];

const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>Acadebility - Terms &amp; Conditions</title>
        <meta name="description" content="Terms & Conditions" />
      </Helmet>

      <div className="lgl-page">
        {/* ── Hero ── */}
        <div className="lgl-hero">
          <div className="lgl-hero-inner">
            <nav className="lgl-breadcrumb">
              <Link to="/">Home</Link>
              <span className="lgl-sep">/</span>
              <span className="lgl-crumb-current">Terms &amp; Conditions</span>
            </nav>
            <h1 className="lgl-title">Terms &amp; Conditions</h1>
            <p className="lgl-subtitle">
              The rules for using Acadebility. Please read this before using the site.
            </p>
            <span className="lgl-updated-badge"><IconClock /> Please review periodically for updates</span>
          </div>
        </div>

        {/* ── Body ── */}
        <div className="lgl-body">
          <div className="lgl-body-inner">

            <nav className="lgl-jumpnav" aria-label="Jump to section">
              {SECTIONS.map(s => (
                <a key={s.id} href={`#${s.id}`} className="lgl-jump-chip">{s.label}</a>
              ))}
            </nav>

            <div className="lgl-layout">

              <main className="lgl-content">

                <section id="acceptance">
                  <h2>Acceptance of Terms</h2>
                  <p className="lgl-lead">
                    These terms and conditions outline the rules and regulations for the use of the Acadebility website. Acadebility is a platform that provides online education. By accessing this website, we assume you accept these terms and conditions in full.
                  </p>
                  <p>
                    Do not continue to use Acadebility if you do not accept all of the terms and conditions stated on this page.
                  </p>
                </section>

                <section id="information-collected">
                  <h2>Information We Collect</h2>
                  <p>
                    What personal information do we collect from the people that visit our blog, website, or app? When ordering or registering on our site, as appropriate, you may be asked to enter your email address or other details to help you with your experience.
                  </p>
                </section>

                <section id="when-we-collect">
                  <h2>When We Collect Information</h2>
                  <p>
                    We collect information from you when you register on our site, subscribe to a newsletter, or enter information on our site.
                  </p>
                </section>

                <section id="how-we-use">
                  <h2>How We Use Your Information</h2>
                  <p>
                    We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features, in the following ways:
                  </p>
                  <ul>
                    <li>To improve our website in order to better serve you.</li>
                    <li>To improve customer service requests.</li>
                    <li>To send periodic emails.</li>
                  </ul>
                </section>

                <section id="changes">
                  <h2>Changes to These Terms</h2>
                  <p>
                    We may update these terms and conditions from time to time. Continued use of Acadebility after any changes are posted constitutes your acceptance of the revised terms, so please check this page periodically.
                  </p>
                </section>

                <section id="contact">
                  <h2>Contact Us</h2>
                  <p>Don't hesitate to contact us if you have any query.</p>
                  <ul>
                    <li>Via Email: <a href="mailto:acadebility@gmail.com">acadebility@gmail.com</a></li>
                  </ul>
                </section>

              </main>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;